import { retrieveCreditProfile } from 'actions/creditInfo.actions';
import { getCsid3BDial } from 'actions/csid3BDial.actions';
import { pinkyPromise } from 'helpers/promiseHelper';
import { removeThinfileStorage } from './thinFile.actions';
import { fetchCurrent3BCreditReport } from 'externals/_services/creditReport.service';
import { getUserInfo } from './userInfo.actions';
import { clearCreditManager } from 'actions/creditManager.actions';
import { createLogger } from 'helpers/logger';

const logger = createLogger({
  name: 'premium.actions',
});

export const onPremiumConversion = userInfo => async (dispatch, getState) => {
  if (userInfo?.premiumPlanInfo?.eligibleFor3BCreditReport) {
    try {
      dispatch(removeThinfileStorage());
      const res = await pinkyPromise(fetchCurrent3BCreditReport());
      const returnValues = await Promise.all([
        res,
        dispatch(getUserInfo(true)),
        dispatch(retrieveCreditProfile(true, true)),
        pinkyPromise(dispatch(getCsid3BDial(true))),
      ]);

      return returnValues;
    } catch (e) {
      return [{}, {}, {}];
    }
  } else {
    return [];
  }
};

export const onPremiumConversionImproved =
  userInfo => async (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (userInfo?.premiumPlanInfo?.eligibleFor3BCreditReport) {
        dispatch(removeThinfileStorage());
        fetchCurrent3BCreditReport()
          .then(async res => {
            try {
              const returnValues = await Promise.all([
                res,
                dispatch(getUserInfo(true)),
                dispatch(retrieveCreditProfile(true, true)),
                pinkyPromise(dispatch(getCsid3BDial(true))),
                dispatch(clearCreditManager()),
              ]);
              resolve(returnValues);
            } catch (e) {
              reject([{}, {}, {}]);
            }
          })
          .catch(e => {
            reject(e);
          });
      } else {
        const errorMsg =
          'There was a problem retrieving your report from the credit bureau. Please try again later, or contact support at premium@creditsesame.com';
        reject({
          error: errorMsg,
          message: errorMsg,
          code: 'CR_1005',
        });
      }
    });
  };

export const afterPremiumConversion =
  userInfo => async (dispatch, getState) => {
    if (userInfo?.premiumPlanInfo?.eligibleFor3BCreditReport) {
      try {
        dispatch(removeThinfileStorage());
        const returnValues = await Promise.all([
          dispatch(getUserInfo(true)),
          dispatch(retrieveCreditProfile(true, true)),
          pinkyPromise(dispatch(getCsid3BDial(true))),
        ]);

        return returnValues;
      } catch (e) {
        logger.reportAPIError(e);
        return e;
      }
    } else {
      return null;
    }
  };
